import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Grid2,
  Paper,
  Typography,
  useTheme,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useGetSubmittedByMeFileUploadsQuery } from "store/slices/apis/fileUploadSlice";
import moment from "moment";
import FileUploadDetailsDialog from "components/FileUpload/FileUploadDetailDialog";
import TableComponent from "components/grid";
import { useNavigate, useParams } from "react-router-dom";
import PaginationComponent from "components/ui-components/PaginationComponent";
import FileUploadModal from "components/FileUpload";
import ApproveFileComponentent from "components/action/ApproveFileComponent";
import RejectFileComponentent from "components/action/RejectFileComponent";
import { API_END_POINT } from "config";
import { IoMdSearch } from "react-icons/io";
import { usePermission } from "hooks/usePermission";
import { FILE_VIEW } from "config";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"

const columns = [
  {
    name: "File Name",
    field: "name",
    renderer(params) {
      const fileName = params?.name;
      if (fileName && fileName?.includes("_")) {
        const splitName = fileName?.split("_");
        const lastPart = splitName?.slice(1).join("_");
        return <>{lastPart}</>;
      } else {
        return <>{fileName}</>;
      }
    },
  },
  {
    name: "Uploaded At",
    field: "createdDate",
    renderer(params) {
      return (
        <>
          {params?.createdDate
            ? moment(params.createdDate).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Status",
    field: "status",
  },
  {
    name: "Action",
    field: "action",
    option: {},
  },
];
const fileTypes = [
  { label: "Milestone", value: "Milestone" },
  { label: "WBS", value: "WBS" },
  { label: "Manpower", value: "Manpower" },
  { label: "P&M", value: "P&M" },
  { label: "BOQ", value: "BOQ" },
];

const FilesSubmittedByMe = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [fileType, setfileType] = useState("");
  const [isFileApprove, setIsFileApprove] = useState(false);
  const [isFileReject, setIsFileReject] = useState(false);
  const [rowData, setRowData] = useState(null);
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const fileViewAccess = usePermission(FILE_VIEW)
  const [filters, setFilters] = useState({
    fileType: "",
  });
  const { data, isLoading, refetch } = useGetSubmittedByMeFileUploadsQuery({
    projectId,
    page: pageNumber,
    pageSize: "10",
    type: filters?.fileType,
  });

  useEffect(() => {
    refetch();
  }, []);

  const handleActionView = (id) => {
    window.open(`${API_END_POINT}issues/view/${id?.name}`, "_blank");
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedFileId(null);
  };

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };
  const handleActionAccept = (row) => {
    setIsFileApprove((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };
  const handleActionReject = (row) => {

    setIsFileReject((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <Autocomplete
                options={fileTypes}
                getOptionLabel={(option) => option?.label}
                onChange={(_, newValue) =>
                  setfileType(newValue ? newValue?.value : "")
                }
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    paddingTop: "8px !important",
                    paddingBottom: "7px !important",
                    paddingRight: "0px !important",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="File Type"
                    name="fileType"
                    // slotProps={{ inputLabel: { shrink: true } }}
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#fff",
                      },

                      // "& .MuiInputLabel-root": {
                      //   top: "-6px",
                      // },
                      minWidth: "230px",
                      marginTop: "12px",
                    }}
                  />
                )}
                ListboxProps={{
                  sx: { fontSize: "13px" },
                }}
              />

              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({ fileType });
                }}
                size="large"
                //  startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fontWeight:500, fill:`${theme?.customSettings?.themeColor}` }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
            </Stack>
          </Box>
        </Grid2>

        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: fileViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={data?.data?.pagedFiles}
            actionView={handleActionView}
            actionAccept={handleActionAccept}
            actionReject={handleActionReject}
          />
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <PaginationComponent
              pageNumber={data?.data?.page || 1}
              totalPages={
                Math.ceil(data?.data?.totalRecords / data?.data?.pageSize) || 1
              }
              onPageChange={setPageNumber}
            />
          </Box>
        </Grid2>
      </Grid2>
      <FileUploadDetailsDialog
        selectedFile={selectedFileId}
        open={showDialog}
        onClose={handleCloseDialog}
      />
      <ApproveFileComponentent
        open={isFileApprove}
        cancel={handleActionAccept}
        rowData={rowData}
        openNotification={openNotification}
      />
      <RejectFileComponentent
        open={isFileReject}
        cancel={handleActionReject}
        rowData={rowData}
        openNotification={openNotification}
      />
    </>
  );
};

export default FilesSubmittedByMe;
